import { ref, computed } from 'vue';
import { fetchListings, createListing, updateListing } from '@/services/api';
import { useToast } from '@/composables/use-toast';

export function useListings() {
  const { addToast } = useToast();
  const listings = ref([]);
  const isLoading = ref(false);
  const currentPage = ref(1);
  const pageSize = ref(12);
  const hasMoreItems = ref(true);
  const isEval = ref(false);
  
  const processedListings = computed(() => {
    return listings.value.map(listing => ({
      ...listing,
      image: listing?.preview_image || ''
    }));
  });

  const fetchListingsPage = async (page, isEvalRequest) => {
    isLoading.value = true;
    isEval.value = isEvalRequest;
    try {

      if (page === 1) {
        currentPage.value = 1;
        listings.value = [];
        hasMoreItems.value = true;
      }
      
      const skip = (page - 1) * pageSize.value;
      const listingsData = await fetchListings(skip, pageSize.value, isEvalRequest);
        
      if (page === 1) {
        listings.value = listingsData;
      } else {
        listings.value = [...listings.value, ...listingsData];
      }
      
      hasMoreItems.value = listingsData.length >= pageSize.value;
          
    } catch (error) {
      console.error('Error fetching listings:', error);
    } finally {
      isLoading.value = false;
    }
  };

  const saveListing = async (listingData, editingItemId = null) => {
    try {
      if (editingItemId) {
        await updateListing(editingItemId, listingData);
        addToast('Listing updated successfully!', 'success');
        return true;
      } else {
        await createListing(listingData);
        addToast('New listing created successfully!', 'success');
        return true;
      }
    } catch (error) {
      console.error('Error saving listing:', error);
      addToast('Error saving listing. Please try again.', 'error');
      return false;
    }
  };
  
  const loadMore = async () => {
    if (!hasMoreItems.value || isLoading.value) return;
    currentPage.value += 1;
    await fetchListingsPage(currentPage.value, isEval.value);
  };

  return {
    listings,
    processedListings,
    isLoading,
    hasMoreItems,
    fetchListingsPage,
    saveListing,
    loadMore
  };
}